export default __webpack_public_path__ + "static/media/NoSmoking.626a873b.gif";